import { api } from "./axios";

export const logout = async () => {
  const response = await api.post<string>("v1/patients/logout");
  return response.data;
};
